@let infoText = infoMap().infoText;
@let infoTitle = infoMap().infoTitle;

<div class="flex items-center">
  <h2 class="text-xl font-bold">{{ title() }}</h2>
  @if (description()) {
    <p class="text-neutral-700 text-sm font-light italic ml-3">
      {{ description() }}
    </p>
  }
  <ng-content />
  <div class="flex items-center gap-2 ml-3">
    @if (showNoteButton()) {
      <div class="w-[110px]">
        <icon-button
          icon="note"
          label="Add note"
          variant="secondary"
          size="sm"
          class="w-full"
          (onClick)="noteClick.emit()" />
      </div>
    }
    @if (infoText) {
      <div class="w-[80px]">
        <app-info-button
          [infoText]="infoText"
          [infoTitle]="infoTitle"
          [tooltipPosition]="'right'"
          [asButton]="true" />
      </div>
    }
  </div>
</div>
